<template>
  <!--音频专辑修改  -->
  <div class="topicAdd">
    <div class="add_box">
    
      <el-card>
        <div slot="header" class="clearfix">
          <span>音频专辑</span>
        </div>
        <div class="text item">
          <el-form
            :model="Detaildata"
            :rules="toAdRule"
            label-position="top"
           
            ref="ruleForm"
            style="width: 100%;margin:10px 10px; "
          >
            <el-row>
                  <el-col :span="18">
                <el-form-item label="专辑名字" prop="name">
                  <el-input
                    placeholder="请输入内容"
                    v-model="Detaildata.name"
                    clearable
                    :disabled="(Detaildata.examineStatus == 1 || Detaildata.examineStatus == 3) && allOpen"
                  />
                </el-form-item>
              </el-col>
              
            </el-row>
            <el-row>
               <el-col :span="18">
                <el-form-item label="提供者" prop="producer">
                  <el-input
                    placeholder="请输入内容"
                    v-model="Detaildata.producer"
                    clearable
                    :disabled="(Detaildata.examineStatus == 1 || Detaildata.examineStatus == 3) && allOpen"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
         
             
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="是否热门" prop="isHot">
                  <el-select
                    placeholder="请选择"
                    v-model="Detaildata.isHot"
                    clearable
                    :disabled="(Detaildata.examineStatus == 1 || Detaildata.examineStatus == 3) && allOpen"
                  >
                    <el-option
                      v-for="item in isHots"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <span>哈哈哈{{Detaildata.isRotation}}</span>
                <el-form-item label="是否轮播" prop="isRotation">
                  <el-select
                    placeholder="请选择"
                    v-model="Detaildata.isRotation"
                    clearable
                    :disabled="(Detaildata.examineStatus == 1 || Detaildata.examineStatus == 3) && allOpen"
                  >
                    <el-option
                      v-for="item in isLuns"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="是否上猜你喜欢" prop="isLike">
                  <el-select
                    placeholder="请选择"
                    v-model="Detaildata.isLike"
                    clearable
                    :disabled="(Detaildata.examineStatus == 1 || Detaildata.examineStatus == 3) && allOpen"
                  >
                    <el-option
                      v-for="item in isLikes"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
                  <el-col :span="12">
              <el-form-item label="选择作者" prop="authorId">
                <el-select
                  placeholder="请选择"
                  v-model="Detaildata.authorId"
                  :disabled="(Detaildata.examineStatus == 1 || Detaildata.examineStatus == 3) && allOpen"
                  clearable
                >
                  <el-option
                    v-for="item in author"
                    :key="item.id"
                    :label="item.nickName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="18">
                <el-form-item label="专辑描述" prop="description">
                  <el-input
                    type="textarea"
                    :rows="10"
                    placeholder="请输入内容"
                    v-model="Detaildata.description"
                    clearable
                    :disabled="(Detaildata.examineStatus == 1 || Detaildata.examineStatus == 3) && allOpen"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-form-item label="专辑封面图" prop="frontCoverUrl">
                <el-upload
                  class="avatar-uploader"
                  action="https://jsonplaceholder.typicode.com/posts/"
                  :auto-upload="false"
                  :show-file-list="false"
                  :on-change="TopicUpt"
                  :on-success="TopicSuccess"
                  :before-upload="beforeUpload"
                  :disabled="(Detaildata.examineStatus == 1 || Detaildata.examineStatus == 3) && allOpen"
                >
                  <img v-if="Detaildata.frontCoverUrl" :src="Detaildata.frontCoverUrl" class="avatar" />
                  <!-- <i
                    v-else
                    class="el-icon-plus avatar-uploader-icon"
                    style="marginTop:65px;font-size: 50px;"
                  ></i>-->

                  <i
                    :class="imgLoad ? 'el-icon-loading' : 'el-icon-plus avatar-uploader-icon'"
                    style="marginTop:10px;font-size: 50px;marginLeft:10px"
                    v-else
                  ></i>
                </el-upload>
              </el-form-item>
            </el-row>
            <el-row>
              <el-button
                style="margin-left: 600px"
                type="primary"
                @click="submitAdd('ruleForm')"
                :disabled="(Detaildata.examineStatus == 1 || Detaildata.examineStatus == 3) && allOpen"
                v-if="menuPerm('audio:query')"
              >保存</el-button>
            </el-row>
          </el-form>
        </div>
      </el-card>

      <!-- 专辑下的所有音频的列表 -->
      <el-card>
        <div slot="header" class="clearfix">
          <span>专辑里的音频</span>
        </div>
        <div class="text item">
          <el-row>
            <el-button
              style="margin-left: 120px"
              type="primary"
              @click="audioListAdd"
              :disabled="(Detaildata.examineStatus == 1 || Detaildata.examineStatus == 3) && allOpen"
              v-if="menuPerm('audio:query')"
            >添加音频</el-button>
          </el-row>
          <el-row v-if="audioAdd">
            <el-form
              :model="audioList"
              label-position="right"
              label-width="200px"
              ref="ruleForm"
              style="width: 90%;margin:20px auto; "
            >
              <el-row>
                <!-- :disabled="Detaildata.examineStatus == 1 || Detaildata.examineStatus == 3" -->
                <el-col :span="10">
                  <el-form-item label="音频文件" prop="ossUrl">
                    <el-upload
                      class="audio-upt"
                      action="https://jsonplaceholder.typicode.com/posts/"
                      :auto-upload="false"
                      :show-file-list="false"
                      :on-change="audioLieUpt"
                      :on-success="AudioListSuccess"
                      :before-upload="beforeUpload"
                      ref="uptImg"
                      :disabled="(Detaildata.examineStatus == 1&&this.menuPerm('audio:edit_super')==false)||Detaildata.examineStatus == 3&&this.menuPerm('audio:edit_super')==false"
                    >
                      <audio
                        v-if="audioList.ossUrl"
                        :src="audioList.ossUrl"
                        controls="controls"
                        class="audios"
                      ></audio>

                    

                      <i
                        :class="fileLoad ? 'el-icon-loading' : 'el-icon-plus avatar-uploader-icon'"
                        style="marginTop:10px;font-size: 50px;marginLeft:10px"
                        v-else
                      ></i>
                    </el-upload>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                 <el-col :span="8">
                  <el-form-item label="小集的名字" prop="name">
                    <el-input
                    style="width:150px"
                      placeholder="请输入内容"
                      v-model="audioList.name"
                      clearable
                      :disabled="(Detaildata.examineStatus == 1 || Detaildata.examineStatus == 3) && allOpen"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-button
                  style="margin-left: 200px"
                  type="primary"
                  @click="submitAudio('ruleForm')"
                  :disabled="(Detaildata.examineStatus == 1 || Detaildata.examineStatus == 3) && allOpen"
                  v-if="menuPerm('audio:query')"
                >确认新增</el-button>
              </el-row>
            </el-form>
          </el-row>

          <el-row>
            <el-table
              :data="audioLie"
              :header-cell-style="getRowClass"
              ref="multipleTable"
              style="width: auto; flex: auto"
              tooltip-effect="light"
            >
              <el-table-column prop="ossUrl" label="选集" width="400px" height="200px" align="center">
                <template slot-scope="{row}">
                  <div class="topic_img">
                    <audio :src="row.ossUrl" controls="controls" v-if="row.ossUrl"></audio>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="小集的名字" align="center" width="150px"></el-table-column>
              <el-table-column prop="publishTimestamp" label="发布时间" align="center" width="300px"></el-table-column>
              <el-table-column
                align="center"
                class-name="small-padding fixed-width"
                label="操作"
                width="180px"
              >
                <template slot-scope="{row}">
                  <div class="done">
                    <el-button
                      size="mini"
                      type="primary"
                      @click="getAudioDel(row.id)"
                      :disabled="(Detaildata.examineStatus == 1 || Detaildata.examineStatus == 3) && allOpen"
                      v-if="menuPerm('audio:query')"
                    >删除</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </div>
      </el-card>

      <!-- 获取所有类型的列表 -->

      <el-card>
        <div slot="header" class="clearfix">
          <span>类型管理</span>
        </div>
        <div class="text item">
          <div class="typeList">
            <div class="text" v-for="(item,index) in typeList" :key="index">
              <span
                :class="item.audioAlbumId != null ? 'active' : ''"
                @click="allOpen ? clickOpen  && changeType(item.audioAlbumId,item.id) : changeType(item.audioAlbumId,item.id)"
              >{{item.name}}</span>
            </div>
          </div>
        </div>
      </el-card>
    </div>

    <!-- 删除弹框 -->
    <a-modal
      title
      :visible="delOpen"
      @ok="handleOk"
      ok-text="确认"
      cancel-text="取消"
      @cancel="handleCancel"
    >
      <p>确认删除吗？</p>
    </a-modal>
  </div>
</template>
<script>
import axios from "axios";
import {baseURL} from '../../api/config'
export default {
  data() {
    return {
      allOpen: true, //没有限制
      imgLoad: false, //加载img
      fileLoad: false, //加载文件
      clickOpen: true, //点击类型管理的状态
      delId: "", //删除音频id
      delOpen: false, //删除音频弹框
      audioAdd: false, //专辑添加音频

      xiangOpen: false, //详情禁用

      AudioUptImg: [], //图片上传
      //添加的参数：
      EditList: {
        authorId: "", //作者 id
        name: "", //专辑名字
        description: "", //描述
        frontCoverUrl: "", //封面图
        producer: "" //出品方
      },
      //音频专辑校验：
      toAdRule: {
        authorId: [
          { required: true, message: "内容不能为空", trigger: "blur" }
        ],
        name: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        isHot: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        isRotation: [
          { required: true, message: "内容不能为空", trigger: "blur" }
        ],
        isLike: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        description: [
          { required: true, message: "内容不能为空", trigger: "blur" }
        ],
        producer: [{ required: true, message: "内容不能为空", trigger: "blur" }]
      },
      author: "", //作者

      //   专辑添加音频
      audioList: {
        name: "", // 小集的名字
        ossUrl: "" // 音频文件的 url
      },
      audioLie: [], //专辑下的所有音频的列表
      typeList: "", //获取所有类型的列表
      //是否热门:
      isHots: [
        {
          label: "否",
          value: 0
        },
        {
          label: "是",
          value: 1
        }
      ],
      //是否轮播:
      isLuns: [
        {
          label: "否",
          value: 0
        },
        {
          label: "是",
          value: 1
        }
      ],
      //是否上猜你喜欢
      isLikes: [
        {
          label: "否",
          value: 0
        },
        {
          label: "是",
          value: 1
        }
      ],
      backOpen:true
    };
  },
  props: ["Detaildata"],
  methods: {
    
    //头部样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f5f7fa;color:#000;width:100%;text-aligin:center;text-align: center;";
      } else {
        return "";
      }
    },
    //作者：
    getAuthor() {
      this.getAxios("/manager/list/userInfo", {
        managerId: localStorage.getItem("userId")
      }).then(res => {
        if (res.success == true) {
          this.author = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push('/')
        }else if(res.success==false){
          this.$message.error(res.message);
        }
      });
    },

   
    //转base64
    getBase64(file) {
      return new Promise(function(resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file.raw);
        reader.onload = function() {
          imgResult = reader.result;
        };
        reader.onerror = function(error) {
          reject(error);
        };
        reader.onloadend = function() {
          resolve(imgResult);
        };
      });
    },
    //上传图片限制
    beforeUpload(file, fileList) {
      return new Promise(resolve => {
        // 图片压缩
        let reader = new FileReader(),
          img = new Image();
        reader.readAsDataURL(file);
        reader.onload = function(e) {
          img.src = e.target.result;
        };

        img.onload = function() {
          let canvas = document.createElement("canvas");
          let context = canvas.getContext("2d");
          let width = "100";
          let height = "100";
          let originWidth = width;
          let originHeight = height;

          canvas.width = originWidth;
          canvas.height = originHeight;

          context.clearRect(0, 0, originWidth, originHeight);
          context.drawImage(img, 0, 0, originWidth, originHeight);

          canvas.toBlob(
            blob => {
              let imgFile = new File([blob], file.name, { type: file.type }); // 将blob对象转化为图片文件
              resolve(imgFile);
            },
            file.type,
            0.2
          ); // file压缩的图片类型
        };
      });
    },
    //图片上传：
    TopicUpt(file, fileList) {
      this.imgLoad = true;
      this.AudioUptImg = [];
      this.getBase64(file).then(resBase64 => {
        this.AudioUptImg.push(resBase64);
        if (this.AudioUptImg) {
          this.postAxios("/file/uploadBase64", {
            fileList: this.AudioUptImg
          }).then(res => {
            if (res.success == true) {
              this.$message.success("上传成功");
              this.Detaildata.frontCoverUrl = res.content[0]; //接口url参数
              this.AudioUptImg = [];
            } else if (res.success == false) {
              this.$message.error(res.message);
            }

            if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push("/");
            }
          });
        }
      });
    },
    //音频上传成功：
    AudioListSuccess(file, fileList) {
      this.$refs.uptImg.clearValidate();
    },
    //音频上传：-----线上（本地url）
    audioLieUpt(file, fileList) {
      this.fileLoad = true;
      if (file) {
        let files = file.raw;
        let formdata = new FormData();
        formdata.append("img", files);
        axios
          .post(baseURL + "/file/uploadFile" , formdata, {})
          .then(res => {
            if (res.success == true) {
              this.$message.success(res.message);
              this.audioList.ossUrl = res.entity; //接口url参数
            } else if (res.success == false) {
              this.$message.error(res.message);
            } else if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push("/");
            }
          });
      }
    },

    //提交成功：
    TopicSuccess(res, file) {
      this.$refs.uptImg.clearValidate();
    },
    //新增专题：
    submitAdd(formName) {
      var id = this.Detaildata.id;
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.postAxios("/audio/album/update", {
            id: id,
            authorId: this.Detaildata.authorId, //作者 id
            name: this.Detaildata.name, //专辑名字
            description: this.Detaildata.description, //描述
            frontCoverUrl: this.Detaildata.frontCoverUrl, //封面图
            producer: this.Detaildata.producer, //出品方

            isRotation: this.Detaildata.isRotation, //是否轮播
            isLike: this.Detaildata.isLike, //是否上猜你喜欢
            isHot: this.Detaildata.isHot //是否热门
          }).then(res => {
            if (res.success == true) {
              this.$router.push({ path: "/audio" });
              this.$message.success("修改成功！");
            } else if (res.success == false) {
              this.$message.error(res.message);
            } else if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push('/')
            }
          });
        } else {
          return false;
        }
      });
    },
    //专辑添加音频
    audioListAdd() {
      this.audioAdd = true; //添加模块出现
      (this.audioList.name = ""), //小集的名字
        (this.audioList.ossUrl = "");
    },
    //专辑添加音频--保存
    submitAudio() {
      var id =this.Detaildata.id;
      this.postAxios("/audio/detail/insert", {
        audioAlbumId: id, //专辑的 id
        name: this.audioList.name, //小集的名字
        ossUrl: this.audioList.ossUrl //音频文件的 url
      }).then(res => {
        if (res.success == true) {
          this.getAudioList();
          this.$message.success("专辑添加音频成功");
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push('/')
        }
      });
      this.audioAdd = false;
    },
    //专辑下的所有音频的列表:
    getAudioList() {
      var id = this.Detaildata.id;
      this.getAxios("/audio/detail/list", {
        audioAlbumId: id
      }).then(res => {
        if (res.success == true) {
          this.audioLie = res.content;
          // 时间戳转时间：
          this.audioLie.map((i, index) => {
            if (i.publishTimestamp != null && i.publishTimestamp != 0) {
              var timeTrans = new Date(parseInt(i.publishTimestamp) * 1000);
              let reviewTimestampsd = timeTrans.toLocaleString("chinese", {
                hour12: false
              });
              this.$set(
                this.audioLie[index],
                `publishTimestamp`,
                reviewTimestampsd
              );
            } else {
              this.$set(this.audioLie[index], `publishTimestamp`, "");
            }
          });
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push('/')
        }else if(res.success==false){
          this.$message.error(res.message);
        }
      });
    },
    //删除音频弹框取消
    handleCancel() {
      this.delOpen = false;
    },
    //专辑删除音频--确认
    handleOk() {
      this.getAxios("/audio/detail/delete", {
        id: this.delId
      }).then(res => {
        if (res.success == true) {
          this.getAudioList(); //列表
          this.$message.success("专辑删除音频成功");
          this.delOpen = false;
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push('/')
        }
      });
    },
    //专辑删除音频:
    getAudioDel(id) {
      this.delId = id; //删除id
      this.delOpen = true;
    },
    // 获取所有类型的列表
    getTypeList() {
      var id = this.Detaildata.id;
      this.getAxios("/audio/album/type/list", {
        id: id
      }).then(res => {
        if (res.success == true) {
          this.typeList = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push('/')
        }else if(res.success==false){
          this.$message.error(res.message);
        }
      });
    },
    //专辑----类型
    changeType(audioAlbumId, ids) {
      var id = this.Detaildata.id;
      if (audioAlbumId == null) {
        //专辑绑定类型
        this.getAxios("/audio/album/type/bind", {
          typeId: ids,
          audioAlbumId: id
        }).then(res => {
          if (res.success == true) {
            this.getTypeList();
            this.$message.success("专辑绑定类型成功！");
            this.getTypeList();
          } else if (res.success == false) {
            this.$message.error(res.message);
          } else if (!res.success && res.statusCode == "401") {
            this.$message.error(res.message);
          this.$router.push('/')

          }
        });
      } else if (audioAlbumId != null) {
        //专辑解绑类型
        this.getAxios("/audio/album/type/unbind", {
          typeId: ids,
          audioAlbumId: id
        }).then(res => {
          if (res.success == true) {
            this.getTypeList();
            this.$message.success("专辑解绑类型成功！");
            this.getTypeList();
          } else if (res.success == false) {
            this.$message.error(res.message);
          } else if (!res.success && res.statusCode == "401") {
            this.$message.error(res.message);
          this.$router.push('/')

          }
        });
      }
    }
  },
  created() {
    // this.EditList = this.Detaildata;
    this.getAudioList(); //专辑下的所有音频的列表
    this.getTypeList(); //获取所有类型的列表
  },
  mounted() {
   
    this.getAuthor();

    if (this.menuPerm("audio:edit_super") == true) {
      this.allOpen = false;
    }
    if (this.EditList.examineStatus == 1 || this.EditList.examineStatus == 3) {
      this.clickOpen = false;
    } else {
      this.clickOpen = true;
    }
  },
  watch:{
    Detaildata(newVal,oldVal){
      this.EditList = this.Detaildata;
    this.getAudioList(); //专辑下的所有音频的列表
    this.getTypeList(); //获取所有类型的列表
    }
  }
};
</script>
<style scoped lang="less">
.topicAdd {
  width: 100%;
  height: 100%;
  .add_box {
    width: 95%;
    height: 100%;
    margin: 0 auto;
    .el-card {
      margin-top: 40px;
      /deep/ .el-upload {
        width: 200px;
        height: auto;
        display: inline-block;
        text-align: center;
        cursor: pointer;
        outline: 0;
        border: 2px dashed #eee;
        display: table-cell;
        vertical-align: middle;
        text-align: center;
        img {
          width: 100%;
          height: auto;
        }
      }
      .clearfix:before,
      .clearfix:after {
        display: table;
        content: "";
      }
      .clearfix:after {
        clear: both;
      }
      /deep/ .el-button--primary {
        color: #fff;
        background-color: #409eff;
        border-color: #409eff;
        width: 100px;
      }

      /deep/ audio:not([controls]) {
        display: block !important;
      }

      /deep/ .table {
        width: auto;
        margin-top: 20px;
        .el-table__header {
          width: 100% !important;
        }
      }
      /deep/ .audio-upt .el-upload {
        height: 8px;
        display: table-cell;
        vertical-align: middle;
        text-align: center;

        .audios {
          vertical-align: middle;
        }
      }
      .el-row {
        margin-top: 20px;
      }

      .typeList {
        width: 95%;
        height: auto;
        display: flex;
        flex-wrap: wrap;
        flex-shrink: 3;
        .text {
          width: 30%;
          height: 50px;
          line-height: 50px;
          text-align: center;
          font-size: 30px;
          font-family: "华文彩云";
          .active {
            color: red;
          }
        }
      }
    }
  }
}
</style>